import React from "react";
import styles from "./style.module.css";
import Navbar from "../../../components/atoms/Navbar";
import logo from "../../../assets/images/blitz_logo.svg";

const TermsOfService = () => {
  // Data extracted from the PDF
  const agreementTitle = "Terms of Service";
  const companyName = "BigShort Tails Private Limited (BTPL)";
  const customerDefinition =
    "Customer (company/individual/partnership/proprietorship)";

  const whereasClauses = [
    "BTPL has a tech platform that facilitates logistics services.",
    "Customer desires to avail BTPL's services through the Blitz Platform.",
  ];

  const keySections = [
    {
      title: "Definitions & Interpretation",
      content: [
        "Terms are defined as used in the agreement.  Common legal and business terms apply.",
        "SCHEDULE 1 contains interpretation rules.",
      ],
    },
    {
      title: "Services",
      content: [
        "BTPL provides services as detailed in SCHEDULE 2.",
        "Customer creates an account on the Platform (website/mobile app).",
        "Customer agrees to Platform terms, including privacy, usage, and pricing policies.",
        "Service levels are in SCHEDULE 3.",
      ],
    },
    {
      title: "Orders & Return",
      content: [
        "Customer books delivery orders through the Platform.",
        "A 3-day notice is required for order increases exceeding 20% per month.",
        "Order cancellations after dispatch are chargeable.",
        "Delivery failures due to Customer/end-user issues are chargeable for return to origin (RTO).",
        "Return orders are processed by a new shipping partner at Customer's cost.",
      ],
    },
    {
      title: "Fee and Invoicing",
      content: [
        "Shipping rates are as per SCHEDULE 4 and the Platform's Billing section.",
        "BTPL can modify shipping rates with 15 days' notice.",
        "Customer pays additional fees for extra services (warehousing, COD, returns).",
        "BTPL is not responsible for fulfillment/shipping errors it did not make.",
        "BTPL collects COD amounts and remits them weekly.",
        "BTPL makes 3 delivery attempts for undelivered shipments.",
        "Customer pays taxes/surcharges, including GST, and other charges like address correction fees.",
        "BTPL can (i) adjust COD amounts, (ii) hold shipments/products, (iii) charge 18% interest on overdue payments, and/or (iv) forfeit security deposits for unpaid invoices.",
        "Claims do not affect payment obligations.",
        "Payment model is prepaid; charges are deducted from a wallet.",
        "BTPL will not deduct from the wallet without the Customer's consent, except for service charges.",
      ],
    },
    {
      title: "Weight Calculation",
      content: [
        "BTPL calculates product weight using specific volumetric weight formulas (LxBxH/5000, LxBxH/4000, LxBxH/6000, LxBxH/4500) depending on the courier.",
        "The higher of dead/dry weight or volumetric weight is used.",
        "Customer declares the weight on the Platform.",
        "If the declared weight differs from BTPL's calculation, shipping charges are revised. Customer is notified and has 7 days to accept or reject the updated weight.",
        "Failure to respond within 7 days implies acceptance of the updated weight.",
      ],
    },
    {
      title: "Packaging of the Products",
      content: [
        "Customers are responsible for proper, tamper-proof, and damage-proof packaging.",
        "BTPL is not liable for damage or loss due to inadequate packaging.",
        "BTPL is not responsible for pilferage/damage/alteration/leakage/loss of goods/shipments/inventory.",
        "Customer is responsible for outer packaging.",
        "Prescriptions must be included where applicable.",
        "Customers must provide packaging instructions in advance.",
      ],
    },
    {
      title: "Warranties and Disclaimers",
      content: [
        "(i) Customer will use services lawfully, (ii) has the authority to enter the agreement, and (iii) has obtained necessary approvals.",
        "Products are delivered on a 'SAID TO CONTAIN BASIS'; BTPL does not verify descriptions.",
        "BTPL is a bailee, not an insurer. Customer waives insurance claims, except for shipment loss.",
        "BTPL is not liable if COD is not received due to customer issues.",
        "BTPL is not liable for service deficiencies due to customer's actions.",
        "BTPL is liable for the safety of stored goods at their warehouses, up to the MRP or as specified in clause 8.2.",
        "Customer cannot ship banned, restricted, illegal, prohibited, stolen, or infringing goods, including:",
        "Dangerous goods (flammable liquids, chemicals, batteries, etc.)",
        "Restricted items (precious items, currency, poisons, firearms, hazardous materials, etc.)",
        "BTPL has a zero-tolerance policy for counterfeit or fraudulent products.",
        "Shipping non-essential items in restricted areas (e.g., red zones) incurs a penalty of INR 10,000 per shipment.",
      ],
    },
    {
      title: "Other Terms",
      content: [
        "BTPL may restrict/terminate accounts for misuse or breach of terms, including creating false profiles or infringing IP rights.",
        "BTPL's liability is limited to INR 2000 per shipment, and claims must be raised within 7 days, except for claims with a Certificate of Facts (COF).",
        "Claims for damage must be within 7 days of delivery, and for loss/theft, within 7 days of shipment closure.",
        "For non-connectivity claims, a signed manifest is required within 5 days of pickup.",
        "BTPL will conduct weekly inventory checks and monthly stock counts.",
        "Claims for damaged/pilfered/tampered shipments are only valid if the customer's outer packaging is damaged.",
        "BTPL can set off amounts owed against amounts payable.",
      ],
    },
    {
      title: "Intellectual Property Rights",
      content: [
        "BTPL owns all intellectual property rights related to the Platform.",
        "Customer cannot use BTPL's IP without prior written consent.",
        "BTPL owns all information provided to the Customer.",
        "BTPL can use the Customer's name/logo for promotion.",
      ],
    },
    {
      title: "Confidentiality",
      content: [
        "Confidential information must be kept strictly confidential for 5 years after termination.",
        "This does not apply to publicly available information, legally required disclosures, information known beforehand, independently developed information, or disclosures to professional advisors on a need-to-know basis.",
      ],
    },
    {
      title: "Non Solicitation",
      content: [
        "During the agreement and for 36 months after, the Customer cannot solicit BTPL's clients, partners, vendors, employees, etc.",
      ],
    },
    {
      title: "Indemnification",
      content: [
        "Customer will indemnify BTPL against claims arising from (i) customer's product or order issues, (ii) security breaches, or (iii) breaches of the agreement or applicable law.",
      ],
    },
    {
      title: "Term & Termination",
      content: [
        "The agreement is effective from the Execution Date and continues until terminated.",
        "BTPL can terminate immediately for customer breach or insolvency.",
        "Either party can terminate with 60 days' written notice.",
        "Upon termination, both parties must fulfill outstanding obligations.",
      ],
    },
    {
      title: "Miscellaneous",
      content: [
        "Notices must be in writing to the specified addresses.",
        "The parties are independent contractors.",
        "Customer cannot assign the agreement without BTPL's consent.",
        "Invalid provisions do not affect the rest of the agreement.",
        "Disputes will be resolved by arbitration in Gurgaon, India, under the Arbitration and Conciliation Act, 1996.  The language is English.",
        "The agreement is governed by the laws of India, and the courts of Haryana have exclusive jurisdiction.",
        "Amendments and waivers must be in writing.",
        "The agreement is the entire agreement between the parties.",
        "Force majeure events (e.g., pandemics, riots) excuse non-performance.  If such events last over 60 days, the affected party may terminate.",
        "The agreement may be signed in counterparts, including electronic copies.",
      ],
    },
  ];

  const interpretationRules = [
    "Gender-neutral language applies.",
    "Terms like 'hereto' refer to the whole agreement.",
    "'Including' means 'including, without limitation'.",
    "'Other' is broadly construed.",
    "Days refer to calendar days.",
    "Headings are for convenience only.",
    "Statute references include amendments and subordinate legislation.",
    "No provision is construed against a party based on their drafting participation.",
    "References to agreements include amendments.",
    "Schedules are an integral part of the agreement.",
  ];

  const servicesProvided = [
    "BTPL allocates orders to shipping partners or allows the Customer to choose.",
    "BTPL provides an Air Waybill Number and tracking link.",
    "BTPL and its partners will pick up the shipment with a signed manifest.",
    "BTPL provides free WMS and OMS to the Customer.",
    "BTPL provides a dedicated Account Manager for support within 24 hours.",
  ];

  const serviceLevelAgreement = {
    title: "Service Level Agreement",
    shippingServices: [
      "Order receipt to Pickup: Cut-off time or 2 days (in case of holidays)",
      "Delivery Attempt after Pickup:",
      "Within City: 1 day or as mentioned on the customer panel",
      "Within State: 2-3 days or as mentioned on the customer panel",
      "Metro to Metro: 3-4 days or as mentioned on the customer panel",
      "Rest of India: 5-6 days or as mentioned on the customer panel",
      "Special Zone: 7-8 days or as mentioned on the customer panel",
    ],
    returnServices: [
      "Return Delivery Attempt after Return Initiation:",
      "Within City: 2-3 days",
      "Within State: 4-7 days",
      "Metro to Metro: 4-10 days",
      "Rest of India: 4-10 days",
      "Special Zone: 7-15 days",
    ],
    note: "*All days mentioned above are working days",
  };

  const shippingRates = {
    title: "Shipping Rates",
    sameDayDelivery: [
      {
        type: "4 Hr Delivery",
        slabs: "5 kg",
        serviceCharges: "205 (37+168)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "4 Hr Delivery",
        slabs: "Additional 1 kg",
        serviceCharges: "28 (4+24)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "4 Hr Delivery",
        slabs: "1 Kg",
        serviceCharges: "70 (15+55)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "4 Hr Delivery",
        slabs: "Additional 500 gms",
        serviceCharges: "32 (4+28)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "12 Hr Delivery",
        slabs: "5 kg",
        serviceCharges: 168,
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "12 Hr Delivery",
        slabs: "Additional 1 kg",
        serviceCharges: 24,
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "12 Hr Delivery",
        slabs: "1 Kg",
        serviceCharges: 55,
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "12 Hr Delivery",
        slabs: "Additional 500 gms",
        serviceCharges: 28,
        codCharges: 35,
        codPercent: "2.00%",
      },
    ],
    nextDayDelivery: [
      {
        type: "24 Hr Delivery",
        slabs: "5 kg",
        serviceCharges: "205 (30+140)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "24 Hr Delivery",
        slabs: "Additional 1 kg",
        serviceCharges: "28 (4+24)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "24 Hr Delivery",
        slabs: "1 Kg",
        serviceCharges: "42 (15+27)",
        codCharges: 35,
        codPercent: "2.00%",
      },
      {
        type: "24 Hr Delivery",
        slabs: "Additional 500 gm",
        serviceCharges: "30 (3+27)",
        codCharges: 35,
        codPercent: "2.00%",
      },
    ],
    b2bDelivery: [
      { chargesPerKg: 13, withinCity: "✓" },
      { chargesPerKg: 15, withinZone: "✓" },
      { chargesPerKg: 16, metroToMetro: "✓" },
      { chargesPerKg: 17, restOfIndia: "✓" },
      { chargesPerKg: 25, specialZone: "✓" },
      { chargesPerKg: "Rs. 500", docketCharges: "✓" },
    ],
    notes: [
      "*RTO Same as Forward",
      "*Vol Weight.-(L*B*H/5000)  (L*B*H/4500 for B2B)",
      "*Price Exclusive of GST",
      "* 24 Hr Delivery Wh Cost is optional",
      "**only one of these charges whichever is higher is applicable.",
    ],
  };

  return (
    <>
      <Navbar noLogo={false} logo={logo} />
      <div className={styles.termsOfServiceContainer}>
        <h1 className={styles.title}>{agreementTitle}</h1>
        <p className={styles.preamble}>
          This agreement is between {companyName} and {customerDefinition}.
        </p>

        <div className={styles.whereasSection}>
          <h2 className={styles.sectionTitle}>WHEREAS</h2>
          <ul className={styles.list}>
            {whereasClauses.map((clause, index) => (
              <li key={index} className={styles.listItem}>
                {clause}
              </li>
            ))}
          </ul>
          <p className={styles.agreementEffective}>
            This Agreement is effective upon service registration or clicking
            "Accept". Registration or clicking "Accept" indicates absolute and
            unconditional consent to the agreement.
          </p>
        </div>

        {keySections.map((section, index) => (
          <div className={styles.section} key={index}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            <ul className={styles.list}>
              {section.content.map((item, i) => (
                <li key={i} className={styles.listItem}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>SCHEDULE 1: Interpretation</h2>
          <ul className={styles.list}>
            {interpretationRules.map((rule, index) => (
              <li key={index} className={styles.listItem}>
                {rule}
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>SCHEDULE 2: Services</h2>
          <ul className={styles.list}>
            {servicesProvided.map((service, index) => (
              <li key={index} className={styles.listItem}>
                {service}
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>{serviceLevelAgreement.title}</h2>
          <h3 className={styles.subsectionTitle}>Shipping Services</h3>
          <ul className={styles.list}>
            {serviceLevelAgreement.shippingServices.map((service, index) => (
              <li key={index} className={styles.listItem}>
                {service}
              </li>
            ))}
          </ul>
          <h3 className={styles.subsectionTitle}>Return Services</h3>
          <ul className={styles.list}>
            {serviceLevelAgreement.returnServices.map((service, index) => (
              <li key={index} className={styles.listItem}>
                {service}
              </li>
            ))}
          </ul>
          <p className={styles.note}>{serviceLevelAgreement.note}</p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>{shippingRates.title}</h2>
          <h3 className={styles.subsectionTitle}>Same-day Delivery Rates</h3>
          <table className={styles.rateTable}>
            <thead className={styles.rateTableHead}>
              <tr>
                <th className={styles.rateTableHeadCell}>Shipping Type</th>
                <th className={styles.rateTableHeadCell}>Slabs</th>
                <th className={styles.rateTableHeadCell}>Service Charges</th>
                <th className={styles.rateTableHeadCell}>COD Charges**</th>
                <th className={styles.rateTableHeadCell}>COD %**</th>
              </tr>
            </thead>
            <tbody>
              {shippingRates.sameDayDelivery.map((rate, index) => (
                <tr key={index}>
                  <td className={styles.rateTableCell}>{rate.type}</td>
                  <td className={styles.rateTableCell}>{rate.slabs}</td>
                  <td className={styles.rateTableCell}>
                    {rate.serviceCharges}
                  </td>
                  <td className={styles.rateTableCell}>{rate.codCharges}</td>
                  <td className={styles.rateTableCell}>{rate.codPercent}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className={styles.subsectionTitle}>Next-day Delivery Rates</h3>
          <table className={styles.rateTable}>
            <thead className={styles.rateTableHead}>
              <tr>
                <th className={styles.rateTableHeadCell}>Shipping Type</th>
                <th className={styles.rateTableHeadCell}>Slabs</th>
                <th className={styles.rateTableHeadCell}>Service Charges</th>
                <th className={styles.rateTableHeadCell}>COD Charges**</th>
                <th className={styles.rateTableHeadCell}>COD %**</th>
              </tr>
            </thead>
            <tbody>
              {shippingRates.nextDayDelivery.map((rate, index) => (
                <tr key={index}>
                  <td className={styles.rateTableCell}>{rate.type}</td>
                  <td className={styles.rateTableCell}>{rate.slabs}</td>
                  <td className={styles.rateTableCell}>
                    {rate.serviceCharges}
                  </td>
                  <td className={styles.rateTableCell}>{rate.codCharges}</td>
                  <td className={styles.rateTableCell}>{rate.codPercent}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className={styles.subsectionTitle}>
            B2B Delivery Rates (Part-truck Load)
          </h3>
          <table className={styles.b2bTable}>
            <thead className={styles.b2bTableHead}>
              <tr>
                <th className={styles.b2bTableCell}></th>
                <th className={styles.b2bTableCell}>Within City</th>
                <th className={styles.b2bTableCell}>Within Zone</th>
                <th className={styles.b2bTableCell}>Metro to Metro</th>
                <th className={styles.b2bTableCell}>Rest of India</th>
                <th className={styles.b2bTableCell}>Special Zone</th>
                <th className={styles.b2bTableCell}>Docket Charges</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.b2bTableCell}>Charges / Kg</td>
                {shippingRates.b2bDelivery.map((rate, index) => (
                  <td key={index} className={styles.b2bTableCell}>
                    {rate.chargesPerKg || rate.docketCharges}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
          <ul className={styles.notesList}>
            {shippingRates.notes.map((note, index) => (
              <li key={index} className={styles.noteItem}>
                {note}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
